const styles = {
  "nav-bar": "_nav-bar_135dy_16",
  "nav-bar-items": "_nav-bar-items_135dy_22",
  "nav-tab": "_nav-tab_135dy_33",
  "nav-item": "_nav-item_135dy_55"
};
export {
  styles as default
};
//# sourceMappingURL=Nav.module.css.js.map
